module.exports = __webpack_public_path__ + "static/img/star-big.3f267990.webp";